import { ActivatedRoute, Router, NavigationStart, RouterModule } from '@angular/router';
import { GlobalServiceService } from "../shared/services/global-service.service";
import { Component, OnInit, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser, isPlatformServer, CommonModule } from '@angular/common';
import { MessagingServiceService } from "../shared/services/messaging-service.service";
import { PatientProfileService } from "../shared/services/patient-profile.service";
import { GlobalHeaderComponent } from './global-header/global-header.component';
import { GlobalFooterComponent } from './global-footer/global-footer.component';

@Component({
    selector: 'dc-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    standalone: true,
    imports: [CommonModule, RouterModule, GlobalHeaderComponent, GlobalFooterComponent]
})

export class LayoutComponent implements OnInit {

  user: any;
  dentist_id
  patient_id
  pageLink
  id
  type
  showHeadFooter = true;
    private localStorage: Storage = {
    getItem: () => "",
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
    length: 0,
    key: () => null,
  } satisfies Storage;
  private window: Window;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private pService: PatientProfileService,
    private global: GlobalServiceService,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.window = window;
      this.localStorage = window.localStorage;
    }
  }

  ngOnInit() {

      if(this.router.url == '/dentist/lp'){
        this.showHeadFooter = false;
      }

      this.router.events.forEach((event) => {
        if (event instanceof NavigationStart) {
          if (event['url'] == "/marketplace/vendor/signup" || event['url'] == "/dentist/signup_new" || event['url'] == '/patient/register_2' || event['url'] == '/dentist/lp' || event['url'] == '/dentist-signup' || event['url'] == '/patient-registration') {
            this.showHeadFooter = false;
          } else {
            this.showHeadFooter = true;
          }
          // hide footer only
          if (event['url'] == '/best-dentists-listing-limited-time' || event['url'] == '/greensky' || event['url'] == '/keating' || event['url'] == '/specialoffer' || event['url'].indexOf("meeting-room/") > -1 || event['url'] == '/dentist/list-practice' || event['url'] == '/bestdentaloffer' || event['url'] == '/teledentaloffer') this.global.hideFooterOnly.next(1);
          else this.global.hideFooterOnly.next(0);
        }
      });
      // console.log('activated route url without get parameter', this.router.url.indexOf("meeting-room/"));

      if(this.router.url == "/marketplace/vendor/signup" || this.router.url == "/dentist/signup_new" || this.router.url == '/patient/register_2' || this.router.url === "/dentist-signup" || this.router.url === "/patient-registration") {
        this.showHeadFooter = false;
      }

      // hide footer only
      if (this.router.url == '/best-dentists-listing-limited-time' || this.router.url == '/greensky' || this.router.url == '/keating' || this.router.url == '/specialoffer' || this.router.url.indexOf("meeting-room/") > -1 || this.router.url === '/dentist/list-practice' || this.router.url === '/bestdentaloffer' || this.router.url == '/teledentaloffer') this.global.hideFooterOnly.next(1);

      if(this.route.snapshot.queryParamMap.get('show')) {
        var show = parseInt(this.route.snapshot.queryParamMap.get('show'));
        if(show == 0) {
          var currUrl = this.router.url.split('?')[0];
          if(currUrl === "/privacy-policy" || currUrl === "/terms-and-conditions" || currUrl === "/hipaa-authorization") {
            this.showHeadFooter = false;
            const body = typeof document !== "undefined" && document.getElementsByTagName("body")[0];
            body.classList.add("dashboard_chatbox");
          }
        }
      }

      /*var domain = this.router.url.split('/');
      var slug = domain[1]

      if(slug == "mydentist"){
         this.showHeadFooter = false;
      }*/

  }

  changeOfRoutes($event) {

    var domain = this.router.url.split('/');
    var slug = domain[1];
    if(slug == "mydentist" || slug == "support") {
      if( typeof localStorage !== "undefined" && localStorage?.getItem("mydentistid")) {
        this.showHeadFooter = true;
      } else {
        this.showHeadFooter = false;
      }
    }
    this.id = 0
    this.type = 0
    if(typeof localStorage !== "undefined" && this.localStorage?.getItem("id") && this.localStorage?.getItem("id") !== null){
      this.id = this.localStorage?.getItem("id")
    }

    if(typeof localStorage !== "undefined" && this.localStorage?.getItem("type") && this.localStorage?.getItem("type") !== null){
      this.type = this.localStorage?.getItem("type")
    }
    this.pageLink = this.router.url
    if(slug == "mydentist" || slug == "patient" || slug == "dentist" || slug == "doctorprofile") {

    } else {
      this.storeLogActivity()
    }

  }

  storeLogActivity() {

    var data: any = {
      'audit_user_id' : this.id,
      'user_type': this.type,
      'audit_action_type':0,
      'asset_id':0,
      'asset_type':0,
      'page':0,
      'page_link': this.pageLink
    }
    this.pService.storeLogActivity(data).subscribe((response: any) => {
      if (response.success == 1) {
      } else {
      }
    },
    error => {
      console.log("Oops! Please try again");
    });

  }

}
